import React, { Component } from 'react'
import { Carousel } from 'react-bootstrap'

import './SliderResponsive.scss'
export default class SliderResponsiveClient extends Component {
  getItemGrouped (items) {
    let groupIndex = 0
    const itemsGrouped = []
    console.log(items.length)
    items.forEach((item, index) => {
      if (itemsGrouped[groupIndex]) {
        itemsGrouped[groupIndex].push(item)
      } else {
        itemsGrouped[groupIndex] = [item]
      }
      groupIndex += (index !== 0
        && ((index + 1) % 4 === 0)
        && 1) || 0
    })

    return itemsGrouped
  }

  render () {

    let items = this.props.items

    var next = <i className='fa fa-angle-right fa-lg'></i>
    var prev = <i className='fa fa-angle-left fa-lg'></i>

    const groupedItems = this.getItemGrouped(items)
    return (
      <div>
        <Carousel indicators nextIcon={next} prevIcon={prev}>
          {groupedItems.map((item, index) =>
            <Carousel.Item key={index}>
              <div className='clients-mobile-slider'>
                {item.map((client) => (
                  <div key={client.image}>
                    <img className='client-image' src={client.image} />
                  </div>)
                )}
              </div>
            </Carousel.Item>
          )}
        </Carousel>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/features/PageCompany/Components/Clients/sliderResponsive.js